<template>
  <div>
    <OverlayPanel
      :ref="'op'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 700px"
    >
      <Button style="float: left;" label="View Customer" icon="pi pi-search" @click="viewCustomer"/>
      <Button style="float: right;" label="View Full History" icon="pi pi-inbox" @click="viewFullHistory"/>
      <br />
      <br />
      <HistoryTable
        :data="customerHistory"
        :name="'Customer History'"
        :loading="customerHistoryLoading"
        :customer="tempCustomer"
      />
    </OverlayPanel>

    <OverlayPanel
      :ref="'opActions'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 400px;"
      :baseZIndex=-10
    >
      <div style="padding: 0px 1px">
        <div class="row" style="background-color: white;">
          <div class="p-field p-col"
            v-for="(obj, index) in getActionButtons1()"
            :key="index"
            style="margin: 0px; text-align: center; padding: 0px;"
          >
            <Button 
              :label="obj.label" 
              :icon="obj.icon"
              :disabled="obj.disabled ? true : false"
              class="p-button-text p-button-plain" 
              @click="runFunction(obj)"
            />
          </div>
        </div>
        <hr />
        <div class="row" style="background-color: white;">
          <div class="col col-lg-6 col-md-6">
            <Button 
              v-for="(obj, index) in actionButtons2" 
              :key="index" 
              :label="obj.label" 
              :icon="obj.icon"
              class="p-button-text p-button-plain" 
              @click="runFunction(obj)"
              :disabled="runDisabledFunction(obj)"
            />
          </div>
          <div class="col col-lg-6 col-md-6">
            <Button 
              v-for="(obj, index) in actionButtons3" 
              :key="index" 
              :label="obj.label" 
              :icon="obj.icon"
              class="p-button-text p-button-plain" 
              @click="runFunction(obj)"
            />
          </div>
        </div>
      </div>
    </OverlayPanel>

    <DataTable
      :key="tableKey" 
      :value="data"
      :expandedRows="expandedRows"
      :paginator="true"
      @row-expand="onRowExpand"
      @row-collapse="onRowCollapse"   
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      dataKey="oppId"
      :rowHover="true"
      :selection.sync="selectedData"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} Enquiries"
      :resizableColumns="true" 
      columnResizeMode="expand"
      @column-resize-end="colsResized"
      :reorderableColumns="false" 
      @column-reorder="colReordered"
      @page="onPage($event)"
      :lazy="true"
      :totalRecords="totalRecords"
      @sort="onSort($event)"
      :sortField="defaultSortField"
      :sortOrder="defaultSortOrder"
      :first="defaultFirstPage"
      :rows="defaultRows"
      @row-click="rowClicked($event)"
      contextMenu
      :contextMenuSelection.sync="selectedRow"
      @row-contextmenu="onRowContextMenu"
      :scrollable="true"
      scrollHeight="400px"
      frozenWidth="50px"
    >
      <template #empty> No Enquiries found. </template>
      <template #loading> Loading enquiries data. Please wait. </template>
      <div
        :key="columnsKey"
      >
        <!-- <Column 
          selectionMode="multiple" 
          headerStyle="width: 3em;"
        ></Column> -->
        <Column 
          header="Actions"
          headerStyle="width: 50px; height: 30px; padding: 10px 0px;"
          :frozen="true"
        >
          <template #body="slotProps">
            <div  
              style="height: 40px; padding: 10px 0px; display: flex; align-items: center;"
            >
              <Button 
                icon="pi pi-ellipsis-v" 
                class="p-button-rounded p-button-text"
                @click="toggleActions($event, slotProps.data)"
              />
            </div>
          </template>
        </Column>
        <Column :expander="true" headerStyle="width: 3rem" />
        <Column 
          v-for="(col, index) of colSelectedFieldsForTable" 
          :key="col.dbField + '_' + index"
          :field="getOptionLabel(col)[0]" 
          :header="col.fieldName" 
          :sortable="true"
          :headerStyle="'width: ' + col.defWidth + 'px; height: 41px;'" 
        >
          <template #body="slotProps">
            <div v-if="inlineKindForCol(col)" @click.stop>
              <div
                :class="canInlineEdit(slotProps.data) ? 'inline-editable-cell' : ''"
                :title="canInlineEdit(slotProps.data) ? 'Click to edit' : ''"
                @click="startInlineEdit(slotProps.data, inlineKindForCol(col), col)"
              >
                {{ getToShow(slotProps.data, col) || '—' }}
              </div>
            </div>
            <template v-else>
              <div
                style="display: flex; justify-content: space-between; align-items: center;"
              >
                <div
                  style="height: 40px; padding: 10px 0px;"
                  @click="openOP(slotProps.data, col, $event)"
                  :class="getStyle2(col)"
                >
                  {{ getToShow(slotProps.data, col) }}
                </div>
                <div
                  @click="viewNotes(slotProps.data)"
                >
                  <Badge
                    v-if="col && col.fieldName === 'Quote No' && slotProps.data && slotProps.data.notesCount"
                    class="ignore"
                    :value="slotProps.data.notesCount"
                    style="cursor: pointer;"
                  ></Badge>
                </div>
              </div>
            </template>
          </template>
        </Column>
        <Column
          header="Status"
          :sortable="true"
          headerStyle="width: 10em;"
          sortField="oppStatusName"
          filterField="oppStatusName"
        >
          <template #body="slotProps">
            <span 
              v-on:click="changeStatus(slotProps.data, $event)"
              :class="'ignore pointer badge ' + getStyle(slotProps.data)" 
            >
              {{ slotProps.data.oppStatusName }}
            </span>
            
            <OverlayPanel 
              ref="statuses" 
              appendTo="body" 
              :showCloseIcon="true" 
              id="statuses" 
              style="width: 120px"
            > 
              <div
                v-for="(val, index) in tempOpportunityStatuses"
                :key="index"
              >
                <span 
                  @click="updateStatus(val)" 
                  :class="'ignore pointer badge ' + getStyle(val)" 
                >
                  {{ val.oppStatusName }} 
                </span>
                <br />
                <br />
              </div>
            </OverlayPanel>
          </template>
        </Column>
        <!-- <Column 
          header="Actions"
          headerStyle="width: 9em;"
        >
          <template #body="slotProps">
            <div
              class="splitButtonColumn"
              :style="{position: 'absolute'}"
            >
              <SplitButton 
                label="View" 
                icon="pi pi-info" 
                @click="viewOpportunity(slotProps.data)" 
                :model="getButtons(slotProps.data)"
              > 
              </SplitButton>
            </div>
          </template>
        </Column> -->
      </div>
            <!-- :rowClass="rowClass" -->
      <template #expansion="slotProps">
        <div class="orders-subtable" style="background-color: #44a4f4; color: white; padding: 5px;">
          <h5>Quotations for "{{ slotProps.data.oppDescription }}"</h5>
          <DataTable
            :value="quotations"
            :loading="quotationLoading"
            class="p-datatable-sm"
            dataKey="quoteVerId"
            :selection.sync="selectedQuotations"
            :scrollable="true"
            scrollHeight="400px"
            :style="{ 'width': '100%' }"
          >
            <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
            <Column 
              v-for="(col, index) of colSelectedFieldsForTable1" 
              :key="col.dbField + '_' + index"
              :field="getOptionLabel(col)[0]" 
              :header="col.fieldName" 
              :sortable="true"
              :headerStyle="'width: ' + col.defWidth + 'px;'" 
            >
              <template #body="slotProps">
                <div
                >
                  {{ getToShow(slotProps.data, col) }}
                </div>
              </template>
            </Column>
            <Column
              header="Status"
              :sortable="true"
              sortField="quoteStatus.statusName"
              filterField="quoteStatus.statusName"
              headerStyle="width: 5em; text-align: center"
            >
              <template #body="slotProps">
                <span 
                  :class="'badge ' + getStyle1(slotProps.data.quoteStatus)" 
                  style="font-size: 16px;"
                >
                  {{ slotProps.data.quoteStatus && slotProps.data.quoteStatus.statusName ? slotProps.data.quoteStatus.statusName : '' }}
                </span>
              </template>
            </Column>
            <Column headerStyle="width:2rem">
              <template #body="slotProps">
                <div
                >
                  <Button icon="pi pi-search" @click="viewQuotationDetails(slotProps.data)"/>
                </div>
              </template>
            </Column>
          </DataTable>
        </div>
      </template>
    </DataTable>

    <!-- Inline edit popup for Grade / Enquiry Type (Update button at the bottom) -->
    <Dialog
      :visible.sync="inlineDialogVisible"
      :modal="true"
      :header="inlineDialogHeader"
      :closable="!inlineSaving"
      :style="{ width: '360px' }"
    >
      <div style="padding-top: 4px;">
        <Dropdown
          v-model="inlinePendingValue"
          :options="inlineEditing ? inlineOptionsFor(inlineEditing.kind) : []"
          :optionLabel="inlineEditing ? inlineOptionLabelFor(inlineEditing.kind) : 'name'"
          optionValue="id"
          appendTo="body"
          :placeholder="(inlineEditing && inlineEditing.kind === 'grade') ? 'Select grade' : 'Select enquiry type'"
          :disabled="inlineSaving"
          style="width: 100%;"
        />
      </div>
      <template #footer>
        <Button label="Cancel" class="p-button-text" :disabled="inlineSaving" @click="cancelInlineEdit()" />
        <Button
          label="Update"
          icon="pi pi-check"
          class="p-button-success"
          :disabled="inlineSaving || inlinePendingValue == null"
          @click="commitInlineEdit()"
        />
      </template>
    </Dialog>

    <div class="flex justify_space_between my-1">
      <div>
        <!-- Page Totals are
        &nbsp;
        {{ pageTotal }} -->
      </div>
      <div v-if="showExportButton"
        style="width: 250px; display: flex; justify-content: flex-end;" 
      >
        <ProgressSpinner
          v-if="makingExport"
          style="width:100%; height:25px;" 
          strokeWidth="5" 
          fill="#EEEEEE" 
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Export Enquiries to Excel"
          icon="pi pi-external-link"
          style="width: 210px;"
          @click="$emit('exportData')"
        />
      </div>
    </div>

    <ContextMenu :model="getButtons(selectedRow)" ref="cm" />

    <CommentBox
      :reload="reloadCommentBox"
      :commentDialog="commentDialog"
      label="Please give details below"
      :sendingRequest="sendingRequest"
      @close="commentDialog = false"
      @save="addComment"
    />

    <LostStatusDialog
      :reload="reloadLostStatusBox"
      :lostDialog="lostDialog"
      :sendingRequest="sendingRequest"
      @close="lostDialog = false"
      @save="addLost"
    />

    <Dialog header="Success" :visible.sync="reActiveWarning" :style="{width: '350px'}" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-info-circle p-mr-3" style="font-size: 2rem" />
        <span>Are you sure you wish to reopen this Enquiry?</span>
      </div>
      <template #footer>
        <Button label="Cancel" icon="pi pi-times" @click="reActiveWarning = false" class="p-button-text" autofocus />
        <Button label="Ok" icon="pi pi-check" @click="reActiveEnquiry()" class="p-button-text" autofocus />
      </template>
    </Dialog>

    <Dialog header="Success" :visible.sync="reopenWarning" :style="{width: '350px'}" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-info-circle p-mr-3" style="font-size: 2rem" />
        <span>To set an Enquiry to Active Again, please set the related Active Quote to Active and this will set the Enquiry to Active status.</span>
      </div>
      <template #footer>
        <Button label="Ok" icon="pi pi-check" @click="reopenWarning = false" class="p-button-text" autofocus />
      </template>
    </Dialog>

    <Dialog header="Success" :visible.sync="cancelledNewConfirmation" :style="{width: '350px'}" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-info-circle p-mr-3" style="font-size: 2rem" />
        <span>Confirm setting {{ tempOpportunity.opportunityStatus ? tempOpportunity.opportunityStatus.oppStatusName : '' }} Quote back to {{ tempObj.oppStatusName }} Status?</span>
      </div>
      <template #footer>
        <Button label="Cancel" icon="pi pi-times" @click="cancelledNewConfirmation = false" class="p-button-text" autofocus />
        <Button label="Ok" icon="pi pi-check" @click="reActiveEnquiry()" class="p-button-text" autofocus />
      </template>
    </Dialog>

    <Dialog header="Success" :visible.sync="statusConfirmation" :style="{width: '350px'}" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-info-circle p-mr-3" style="font-size: 2rem" />
        <span>Confirm setting {{ tempOpportunity.opportunityStatus ? tempOpportunity.opportunityStatus.oppStatusName : '' }} Quote back to {{ tempObj.oppStatusName }} Status?</span>
      </div>
      <template #footer>
        <Button label="Cancel" icon="pi pi-times" @click="statusConfirmation = false" class="p-button-text" autofocus />
        <Button label="Ok" icon="pi pi-check" @click="reActiveEnquiry()" class="p-button-text" autofocus />
      </template>
    </Dialog>

    <Dialog header="Success" :visible.sync="newActiveWarning" :style="{width: '350px'}" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-info-circle p-mr-3" style="font-size: 2rem" />
        <span>You must Book In the Enquiry to make it Active.</span>
      </div>
      <template #footer>
        <Button label="Ok" icon="pi pi-check" @click="newActiveWarning = false" class="p-button-text" autofocus />
      </template>
    </Dialog>

    <Dialog header="Success" :visible.sync="newWonWarning" :style="{width: '350px'}" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-info-circle p-mr-3" style="font-size: 2rem" />
        <span>Please Book In Quote, and set it to Won to set the Enquiry as Won.</span>
      </div>
      <template #footer>
        <Button label="Ok" icon="pi pi-check" @click="newWonWarning = false" class="p-button-text" autofocus />
      </template>
    </Dialog>

    <Dialog header="Success" :visible.sync="newActiveCancelWarning" :style="{width: '350px'}" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-info-circle p-mr-3" style="font-size: 2rem" />
        <span>Only New Quotes can be set to Cancelled!.</span>
      </div>
      <template #footer>
        <Button label="Ok" icon="pi pi-check" @click="newActiveCancelWarning = false" class="p-button-text" autofocus />
      </template>
    </Dialog>

    <WonDialog
      :reload="reloadWonDialog"
      :wonDialog="wonDialog"
      label="Enter PO/Order Details:"
      :sendingRequest="sendingRequest"
      @close="wonDialog = false"
      @save="addWonDetails"
    />

    <NoteForm
      v-if="noteDialog"
      :reload="reloadNoteForm"
      :noteDialog="noteDialog"
      :noteToEdit="note"
      :disabledArray="['enquiry', 'Customer']"
      @close="noteDialog = false"
      @noteSaved="noteSaved"
    />

    <Dialog header="Confirmation" :visible.sync="displayConfirmation" :style="{width: '350px'}" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>Are you sure you want to proceed?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text"/>
        <Button label="Yes" icon="pi pi-check" @click="confirmDelete" class="p-button-text" autofocus />
      </template>
    </Dialog> 

  </div>
</template>

<script>
import OpportunityService from "@/service/OpportunityService"
import QuotationService from "@/service/QuotationService"
import CustomerService from "@/service/CustomerService"
import FiltersService from "@/service/FiltersSerice"
import AttachmentService from "@/service/AttachmentService"

import HistoryTable from '../customer/customerHistoryTable'
import CommentBox from '@/mbp/universalComponents/quotation/CommentBox'
import WonDialog from '@/mbp/universalComponents/quotation/WonDialog'
import LostStatusDialog from '@/mbp/universalComponents/quotation/LostStatusDialog'
import NoteForm from '@/mbp/universalComponents/note/NoteForm'

import {
  columnSelectionRequest
} from '../sendRequest'

export default {
  components: {
    HistoryTable,
    CommentBox,
    WonDialog,
    LostStatusDialog,
    NoteForm
  },
  created() {
      
    this.setupComponent()
    
    // Only won quote status is required when I update active enquiry to won
    this.quotationService
      .getAllActiveQuotationStatuses()
      .then(data => {
        this.wonQuoteStatus = data.filter(a => a.statusName === 'Won')
        let a = []
        a = data.filter(a => a.statusName === 'Lost')
        if (a && a[0]) {
          this.lostQuoteStatus = a[0]
        }
      })
      .catch(err => {
        
              
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while quotation statuses",
        //   life: 5000,
        // })
        this.$store.dispatch('addErrorMessage', {
          severity: 'error',
          content: 'Some data was not loaded from "activeQuoteStatuses"'
        })
      })

    this.loadInlineEditOptions()
  },
  mounted() {
    setTimeout(() => {
      this.setSplitButtonLocations()
    }, 100)

    this.calculatePageTotals()
  },
  updated() {
    setTimeout(() => {
      this.setSplitButtonLocations()
    }, 100)
  },
  props: [
    'dbView',
    'data',
    'loading',
    'dbViewFields',
    'colSelectedFields',
    'colSelectedFieldsForTable',
    'totalRecords',
    'rows',
    'currentPage',
    'reloadTable',
    'colSelectedFieldsForTable1',
    'opportunityStatuses',
    'showExportButton',
    'makingExport'
  ],
  data: () => ({
    opportunityService: new OpportunityService(),
    quotationService: new QuotationService(),
    customerService: new CustomerService(),
    filtersService: new FiltersService(),
    attachmentService: new AttachmentService(),
    selectedData: null,
    selectedRow: null,
    selected: [], // columns selected
    customerHistory: [],
    customerHistoryLoading: false,
    expandedRows: [],
    quotations: [],
    tempOpportunityStatuses: [],
    tempOpportunity: {},
    tempObj: {},

    previousPage: null,
    tableKey1: 0,
    columnsKey1: 0,
    defaultSortField: '',
    defaultSortOrder: 0,
    defaultFirstPage: 1,
    defaultRows: 25,
    sendingRequest: false,
    quotationLoading: false,
    selectedQuotations: null,
    
    commentDialog: false,
    wonDialog: false,
    reloadCommentBox: 0,
    reloadWonDialog: 0,
    reActiveWarning: false,
    reopenWarning: false,
    thisEnquiryQuotations: [],
    
    deleteSavedFilterWarning: false,
    newActiveWarning: false,
    newActiveCancelWarning: false,
    newWonWarning: false,
    statusConfirmation: false,
    cancelledNewConfirmation: false,
    lostDialog: false,
    reloadLostStatusBox: 0,
    quotation: {},
    file: {},
    wonQuoteStatus: {},
    lostQuoteStatus: {},

    actionButtons2: [
      {
        label: 'Book In',
        icon: 'pi pi-plus',
        disabledFunction: (that) => {
          return that.requestingCustomer
        },
        command: (that) => {
          that.$emit("newQuote", that.selectedRow);
        }
      },
      {
        label: 'Edit Active Quote',
        icon: 'pi pi-pencil',
        disabledFunction: (that) => {
          return false
        },
        command: (that) => {
          that.$emit("editActiveQuote", that.selectedRow);
        }
      },
      {
        label: 'View quotations',
        icon: 'pi pi-money-bill',
        disabledFunction: (that) => {
          return false
        },
        command: (that) => {
          that.viewQuotations(that.selectedRow)
        }
      },
      {
        label: 'View Activities',
        icon: 'pi pi-calendar',
        disabledFunction: (that) => {
          return false
        },
        command: (that) => {
          that.viewActivities(that.selectedRow)
        }
      },
      {
        label: 'View Attachments',
        icon: 'pi pi-file',
        disabledFunction: (that) => {
          return false
        },
        command: (that) => {
          that.viewAttachments(that.selectedRow)
        }
      }
    ],
    actionButtons3: [
      {
        label: 'New Note',
        icon: 'pi pi-align-justify',
        command: (that) => {
          that.newNote(that.selectedRow)
        }
      },
      {
        label: 'View Notes',
        icon: 'pi pi-align-justify',
        disabledFunction: (that) => {
          return false
        },
        command: (that) => {
          that.viewNotes(that.selectedRow)
        }
      },
    ],
    note: {},
    noteDialog: false,
    reloadNoteForm: 0, // this is not the key
    tempCustomer: {},
    requestingCustomer: false,

    pageTotal: 0,
    updateQuote: false,
    displayConfirmation: false,

    // --- inline grade/type edit ---
    inlineGrades: [],          // active quote grades
    inlineProjTypes: [],       // active project types (Enquiry Type)
    inlineEditing: null,       // { oppId, kind, row, col } while the edit popup is open
    inlinePendingValue: null,  // id selected in the popup; saved on the Update click
    inlineDialogVisible: false,
    inlineSaving: false,
    GRADE_HEADER: 'Grade',         // grade column label -> dbField quoteGrade (active quote's grade)
    TYPE_HEADER: 'Enquiry Type',   // enquiry-type column label -> dbField projTypeName (enquiry's project type)
    BLOCKED_STATUSES: ['Cancelled', 'Won', 'Lost', 'Expired']
  }),
  computed: {
    inlineDialogHeader() {
      if (!this.inlineEditing) return ''
      return this.inlineEditing.kind === 'grade' ? 'Change Grade' : 'Change Enquiry Type'
    },
    splitButtonLocationReset() {
      return this.$store.getters.getSplitButtonLocationReset
    },
    tableKey: {
      set(val) {
        this.tableKey1++
      }, 
      get() {
        return 'tableKey-' + this.tableKey1.toString()
      }
    },
    columnsKey: {
      set(val) {
        this.columnsKey1++
      }, 
      get() {
        return 'columnKey-' + this.columnsKey1.toString()
      }
    }
  },
  watch: {
    splitButtonLocationReset(val) {
      this.setSplitButtonLocations()
    },
    rows(val) {
      this.defaultRows = val
    },
    currentPage(val) {
      this.defaultFirstPage = (val - 1) * this.defaultRows
    },
    reloadTable(val) {
      
      this.setupComponent()

      this.tableKey++
    },
    data(val) {
      this.columnsKey++

      this.calculatePageTotals()
    },
    selected(val) {
      
      if (val && val[0] && val[0].id) {
        this.sendingRequest = false
        this.setSplitButtonLocations()
        columnSelectionRequest(this, 'OpportunityTableForLazyLoadingWithResize.vue')
      }
    },
    colSelectedFieldsForTable(val) {
      
      this.columnsKey++
      // setTimeout(() => this.colSelectedFieldsForTable.forEach(a => 
    }
  },
  methods: {
    noteSaved() {
      this.noteDialog = false;
      this.note = {};
    },
    newNote(enquiry) {
      
      if (enquiry.customerId) {
        this.note = {
          customer: {
            customerId: enquiry.customerId,
            custName: enquiry.custName
          },
          enquiry: enquiry
        };
      }
      this.noteDialog = true;
      this.reloadNoteForm++
    },
    onRowContextMenu(event) {
      // this.$refs.cm.show(event.originalEvent);
    },
    rowClicked(event) {
      if (
        event 
        && event.originalEvent 
        && event.originalEvent.target 
        && (
          event.originalEvent.target.classList.contains("under_lined")
          ||
          event.originalEvent.target.classList.contains("ignore")
        )
      ) {
        return
      } else {
        this.viewOpportunity(event.data)
      }
    },
    setSplitButtonLocations() {
      let a = document.getElementsByClassName('splitButtonColumn')
      // 
      if (a) {
        a.forEach(div => {
          // 
          div.style.top = (div.parentElement.offsetTop + 10).toString() + 'px'
          div.style.left = (div.parentElement.offsetLeft + 10).toString() + 'px'
        })
      }
    },
    setupComponent() {
      
      
      if (this.$store.getters['enquiries/getSortField']) {
        this.defaultSortField = this.$store.getters['enquiries/getSortField']
        this.defaultSortOrder = this.$store.getters['enquiries/getSortOrder']
        
      } else {
        this.defaultSortField = ''
        this.defaultSortOrder = 0
      }

      this.defaultRows = this.$store.getters['enquiries/getRows']
      this.defaultFirstPage = (this.$store.getters['enquiries/getPage'] - 1) * this.defaultRows

    },
    onSort(event) {
      // 
      this.colSelectedFieldsForTable.forEach(element => {
        let a = element.dbField.split('.')
        if (a[a.length - 1] === event.sortField) {
          // 
          this.$emit('sortChange', {
            sortField: event.sortField,
            sortFieldId: element.id,
            sortOrder: event.sortOrder
          })
        }
      })
    },
    onPage(event) {
      // 
      if (!(this.previousPage && event.page === this.previousPage.page && event.rows === this.previousPage.rows && event.pageCount === this.previousPage.totalpages)) {
        this.previousPage = {
          page: event.page + 1,
          rows: event.rows,
          totalPages: event.pageCount
        }
        this.$emit('lazyNext', this.previousPage)
      }
    },
    reActiveEnquiry() {
      this.reActiveWarning = false
      this.cancelledNewConfirmation = false
      this.statusConfirmation = false
      this.sendingRequest = true
      this.tempOpportunity.opportunityStatus = this.tempObj
      
      this.opportunityService
        .updateOpportunityStatus(this.tempOpportunity.oppId, {
          opportunityStatus: this.tempObj.id
        })
        .then(data => {
          this.tempObj = {}
          this.tempOpportunity = {}
          this.sendingRequest = false

          this.$emit('reload')

          this.$toast.add({
            severity: "success",
            summary: "Status updated",
            detail: "Enquiry status has been updated.",
            life: 5000,
          })
        })
        .catch(error => {
          
          this.sendingRequest = false

          this.$toast.add({
            severity: "error",
            summary: "Status update error",
            detail: "Couldn't update status.",
            life: 5000,
          })
        })
    },
    addLost({ reason, comment }) {
      
      this.tempOpportunity.lostQuoteReason = reason
      this.tempOpportunity.statusComment = comment
      this.tempOpportunity.opportunityStatus = this.tempObj
      
      this.sendingRequest = true

      if (!this.updateQuote) {
        this.opportunityService
          .updateOpportunityStatus(this.tempOpportunity.oppId, {
            opportunityStatus: this.tempObj.id,
            statusComment: comment,
            lostQuoteReason: reason.id
          })
          .then(data => {
            this.tempObj = {}
            this.tempOpportunity = {}
            this.sendingRequest = false
            this.lostDialog = false

            this.$emit('reload')

            this.$toast.add({
              severity: "success",
              summary: "Status updated",
              detail: "Enquiry status has been updated.",
              life: 5000,
            })
          })
          .catch(error => {
            
            this.sendingRequest = false
            this.lostDialog = false

            this.$toast.add({
              severity: "error",
              summary: "Status update error",
              detail: "Couldn't update status.",
              life: 5000,
            })
          })

      } else {
        if (this.tempOpportunity && this.tempOpportunity.activeQuoteVerId && reason && reason.id) {
          this.quotation = {
            quoteVerId: this.tempOpportunity.activeQuoteVerId
          }
          

          this.sendQuotePutRequest({
            quoteStatus: this.lostQuoteStatus.id,
            statusComment: comment,
            lostQuoteReason: reason.id
          })
          this.tempObj = {}
        }

      }
    },
    addComment(comment) {
      this.sendingRequest = true
      this.tempOpportunity.statusComment = comment
      this.tempOpportunity.opportunityStatus = this.tempObj

      this.opportunityService
        .updateOpportunityStatus(this.tempOpportunity.oppId, {
          opportunityStatus: this.tempObj.id,
          cancelComment: comment
        })
        .then(data => {
          this.tempObj = {}
          this.tempOpportunity = {}
          this.sendingRequest = false
          this.commentDialog = false

          this.$emit('reload')

          this.$toast.add({
            severity: "success",
            summary: "Status updated",
            detail: "Enquiry status has been updated.",
            life: 5000,
          })
        })
        .catch(error => {
          
          this.sendingRequest = false
          this.commentDialog = false

          this.$toast.add({
            severity: "error",
            summary: "Status update error",
            detail: "Couldn't update status.",
            life: 5000,
          })
        })

    },
    addWonDetails({ file, details, wonManufacturer }) {

      if (this.quotation) {
        this.file = file
        this.quotation.statusComment = details
        this.quotation.quoteStatus = this.wonQuoteStatus
    
        this.sendQuotePutRequest({
          quoteStatus: this.tempObj.id,
          statusComment: details,
          wonManufacturer: wonManufacturer
        })
        this.tempObj = {}
        
        let fileParams = {
          fileName: this.file.name,
          quotation: this.quotation.quoteVerId
        }
        this.attachmentService
          .postFile(file, fileParams)
          .then(res => {
            if (res && res.status === 200) {
              this.$toast.add({
                severity: "success",
                summary: res.data.fileName + " successfully uploaded",
                detail: "File uploaded",
                life: 5000,
              });
            }
          })
          .catch(err => {
            

            if (err && err.response && err.response.data) {
              if (err.response.data.includes("exceeds the configured maximum")) {
                this.$toast.add({
                  severity: "error",
                  summary: "File too big.",
                detail: "File size exceeds the limited size.",
                  life: 5000,
                });
              }
            }

          })
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Quotation not found",
          detail: "Quotation is required to be set as won, please wait and retry...",
          life: 5000,
        })
      }
    },
    sendQuotePutRequest(obj) {

      this.sendingRequest = true
      this.quotationService
        .changeQuoteStatus(this.quotation.quoteVerId, obj)
        .then(data => {
          this.sendingRequest = false
          this.wonDialog = false
          this.commentDialog = false
          this.lostDialog = false
          

          this.quotation = {}
          this.$emit('reload')
        })
        .catch(err => {
          this.sendingRequest = false
          this.wonDialog = false
          this.commentDialog = false
          this.lostDialog = false
          

          if (err.response.status !== 200)
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Unable to update quote status.",
              life: 5000,
            })
        })
    },
    async toggle(event) {
      this.$refs.op.toggle(event);
    },
    getStyle1(data) { // For quotation
      // according to: https://www.w3schools.com/bootstrap4/tryit.asp?filename=trybs_badges2&stacked=h
      if (data && data.colourCode) {
        return data.colourCode
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'lost') {
        return 'badge-danger'
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'active') {
        return 'badge-primary'
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'won') {
        return 'badge-success'
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'cancelled') {
        return 'badge-warning'
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'revised') {
        return 'badge-info'
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'closed') {
        return 'badge-secondary'
      } else {
        return 'badge-dark'
      }
    },
    getAllOpportunityQuotes(oppId) {
      return new Promise(async (resolve, reject) => {
        this.quotationLoading = true

        this.opportunityService
          .getAllOpportunityQuotes(oppId)
          .then(data => {
            this.quotationLoading = false
            resolve(data)
          })
          .catch(err => {
            this.quotationLoading = false
            
                  
            // this.$toast.add({
            //   severity: "error",
            //   summary: "Error",
            //   detail: "Error while getting quotations",
            //   life: 5000,
            // })
            this.$store.dispatch('addErrorMessage', {
              severity: 'error',
              content: 'Some data was not loaded from "opportunityquotes/{customerId}"'
            })

            reject(err)
          })
      })
    },
    onRowExpand(event) {
      setTimeout(() => {
        this.removeActionsExpand()
      }, 50)
      this.quotations = []

      this.expandedRows = this.data.filter(
        (p) => p.oppId === event.data.oppId
      );
      
      this.getAllOpportunityQuotes(event.data.oppId)
        .then(data => {
          this.quotations = data
          setTimeout(() => {
            this.setSplitButtonLocations()
            this.removeActionsExpand()
          }, 50)
        })
        .catch(err => {
        })
    },
    removeActionsExpand() {
      let a = document.getElementsByClassName('orders-subtable')
      if (a[0])
        a[0].style.backgroundColor = 'white'

      let b = document.getElementsByClassName('p-checkbox p-component')
      let c = Math.floor(b.length / 2)
      
      for (let i = 0; i < c; i++) {
        if (b[i]) {
          b[i].style.display = 'none'
        }
      }
    },
    onRowCollapse(event) {
      this.expandedRows = this.expandedRows.filter(
        (p) => p.oppId !== event.data.oppId
      );
      
      this.quotations = []
    },
    viewQuotations(data) {
      this.$router.push({
        path: "/enquiries/" + data.oppId + "/quotations",
        params: { custid: data.oppId },
      });
    },
    viewActivities(data) {
      this.$router.push({
        path: "/enquiries/" + data.oppId + "/activities",
        params: { custid: data.oppId },
      });
    },
    viewNotes(data) {
      

      this.$router.push({
        path: "/enquiries/" + data.oppId + "/notes",
        params: { custid: data.oppId },
      });
    },
    viewAttachments(data) {
      this.$router.push({
        path: "/enquiries/" + data.oppId + "/attachments",
        params: { custid: data.oppId },
      });
    },
    viewQuotationDetails(data) {
      if (data && data.quoteVerId) {
        this.$router.push({
          path: "/quotations/" + data.quoteVerId + "/detail",
          params: { quoteVerId: data.quoteVerId },
        });
      }
    },
    runFunction(obj) {
      this.$refs.opActions.hide();
      obj.command(this)
    },
    runDisabledFunction(obj) {
      if(obj.label == 'Edit Active Quote')
      {
        if(this.selectedRow && this.selectedRow.oppStatusName && this.selectedRow.oppStatusId == 1)
          return false
        else 
          return true
      }
      else
      obj.disabledFunction(this)
    },
    toggleActions(event, data) {
      this.selectedRow = data
      
      this.requestingCustomer = true
      this.customerService
        .getCustomerInfo(data.customerId)
        .then(data => {
          // this.requestingCustomer = false

          this.selectedRow.customer = data
        })
        .catch(err => {
          // this.requestingCustomer = false
          
                
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "customerInfo"'
          })
        })

      if (data && data.oppStatusName === "New") {
        this.actionButtons2[0] = {
          label: 'Book In',
          icon: 'pi pi-plus',
          disabledFunction: (that) => {
            return that.requestingCustomer
          },
          command: () => {
            this.$emit("newQuote", data);
          }
        }
      } else {
        this.actionButtons2[0] = {
          label: 'New Version',
          icon: 'pi pi-plus',
          disabledFunction: (that) => {
            return that.requestingCustomer
          },
          command: () => {
            this.$emit("newQuote", data);
          }
        }
      }

      this.$refs.opActions.toggle(event);
    },
    deleteEnquiry(data) {
      this.displayConfirmation = true
    },
    confirmDelete() {
      this.displayConfirmation = false
      this.$emit("deleteOpportunity", this.selectedRow);
    },
    viewOpportunity(selcust) {
      this.$router.push({
        path: "/enquiries/" + selcust.oppId + "/detail",
        params: { custid: selcust.oppId, selcust },
      });
    },
    getStyle(data) {
      // according to: https://www.w3schools.com/bootstrap4/tryit.asp?filename=trybs_badges2&stacked=h
      if (data) {
        if (data.colourCode) {
          return data.colourCode
        } else if (data.oppStatusName && data.oppStatusName.toLowerCase() === 'active') {
          return 'badge-primary'
        } else if (data.oppStatusName && data.oppStatusName.toLowerCase() === 'lost') {
          return 'badge-danger'
        } else if (data.oppStatusName && data.oppStatusName.toLowerCase() === 'otp') {
          return 'badge-light'
        } else if (data.oppStatusName && data.oppStatusName.toLowerCase() === 'new') {
          return 'badge-info'
        } else if (data.oppStatusName && data.oppStatusName.toLowerCase() === 'cancelled') {
          return 'badge-secondary'
        } else if (data.oppStatusName && data.oppStatusName.toLowerCase() === 'won') {
          return 'badge-success'
        } else if (data.oppStatusName && data.oppStatusName.toLowerCase() === 'tender') {
          return 'badge-warning'
        } else {
          return 'badge-dark'
        }
      } else {
        return 'badge-dark'
      }
    },
    updateStatus(val) {
      // current selected value this.tempOpportunity.oppStatusName
      // the one he want to get change to val.oppStatusName
          if (this.tempOpportunity && this.tempOpportunity.oppId && val.id) {
            
            if (this.tempOpportunity.oppStatusName) {
              this.sendingRequest = false

              if (
                (
                  this.tempOpportunity.oppStatusName !== 'New'
                ) &&
                (
                  val.oppStatusName === 'Cancelled'
                )
               )
               {
                //  this.$toast.add({
                //     severity: "error",
                //     summary: "Status can't be updated",
                //     detail: "Only New Quotes can be set to Cancelled!.",
                //     life: 5000,
                //   })
                this.newActiveCancelWarning = true
               }
              else if (
                (
                  this.tempOpportunity.oppStatusName === 'New'
                ) &&
                (
                  val.oppStatusName === 'Cancelled'
                )
              ) {
                
                this.tempObj = val
                
                this.commentDialog = true
                this.reloadCommentBox++

              } else if (
                (
                  this.tempOpportunity.oppStatusName === 'New'
                ) &&
                val.oppStatusName === 'Lost'
              ) {
                this.tempObj = val
                this.lostDialog = true
                this.updateQuote = false
                this.reloadLostStatusBox++
                
              } else if (
                (
                  this.tempOpportunity.oppStatusName === 'Won' ||
                  this.tempOpportunity.oppStatusName === 'Lost' ||
                  this.tempOpportunity.oppStatusName === 'Cancelled'
                ) &&
                val.oppStatusName === 'Active'
              ) {
                this.tempObj = val
                this.statusConfirmation = true
                
              } else if (
                (
                  this.tempOpportunity.oppStatusName === 'Lost' ||
                  this.tempOpportunity.oppStatusName === 'Cancelled'
                ) &&
                val.oppStatusName === 'New'
              ) {
                this.tempObj = val
                this.cancelledNewConfirmation = true
                
              } else if (
                (
                  this.tempOpportunity.oppStatusName === 'New'
                ) &&
                val.oppStatusName === 'Active'
              ) {
                this.tempObj = val
                this.newActiveWarning = true

              } else if (
                (
                  this.tempOpportunity.oppStatusName === 'New'
                ) &&
                val.oppStatusName === 'Won'
              ) {
                this.tempObj = val
                this.newWonWarning = true

              } else if (
                (
                  this.tempOpportunity.oppStatusName === 'Active'
                ) &&
                (
                  val.oppStatusName === 'Lost'
                )
              ) {

                if (this.tempOpportunity && this.tempOpportunity.activeQuoteVerId) {
                      this.tempObj = val
                      this.updateQuote = true
                      this.lostDialog = true
                      this.reloadLostStatusBox++

                } 
                else {
                  this.$toast.add({
                    severity: "error",
                    summary: "Id not found",
                    detail: "Active quotation id not found...",
                    life: 5000,
                  })

                }




              } else if (
                (
                  this.tempOpportunity.oppStatusName === 'Active'
                ) &&
                (
                  val.oppStatusName === 'Won'
                )
              ) {
                if (this.tempOpportunity && this.tempOpportunity.activeQuoteVerId) {
                  this.tempObj = { ...val, id: 5 }
                  this.wonDialog = true
                  this.reloadWonDialog++

                  this.quotationService
                    .getQuotationInfo(this.tempOpportunity.activeQuoteVerId)
                    .then(data => this.quotation = data)
                    .catch(error => {
                      this.$store.dispatch('addErrorMessage', {
                        severity: 'error',
                        content: 'Some data was not loaded from "quotationinfo/{quoteVerId}"'
                      })
                    })

                } 
                else {
                  this.$toast.add({
                    severity: "error",
                    summary: "Id not found",
                    detail: "Active quotation id not found...",
                    life: 5000,
                  })

                }

              } else if (
                (
                  this.tempOpportunity.oppStatusName === 'Active'
                ) &&
                (
                  val.oppStatusName === 'Cancelled'
                )
              ) {

                if (this.tempOpportunity && this.tempOpportunity.activeQuoteVerId) {
                  this.tempObj = val
                  
                  this.commentDialog = true
                  this.reloadCommentBox++

                } 
                else {
                  this.$toast.add({
                    severity: "error",
                    summary: "Id not found",
                    detail: "Active quotation id not found...",
                    life: 5000,
                  })

                }
              } else if (
                (
                  this.tempOpportunity.oppStatusName === 'Expired'
                ) &&
                val.oppStatusName === 'Active'
              ) {
                // this.tempObj = val
                this.sendingRequest = true
                this.opportunityService
                .updateOpportunityStatusFromExpireToActive(this.tempOpportunity.oppId, {
                  opportunityStatus: val.id
                })
                .then(data => {
                  this.tempObj = {}
                  this.tempOpportunity = {}
                  this.sendingRequest = false
                  this.$emit('reload')
                  this.$toast.add({
                    severity: "success",
                    summary: "Status updated",
                    detail: "Enquiry status has been updated.",
                    life: 5000,
                  })
                })
                .catch(error => {
                  this.sendingRequest = false
                  this.tempObj = val
                  this.reopenWarning = true
                })

              }
            } else {
              this.sendingRequest = true
              this.tempOpportunity = val
              
              this.opportunityService
                .updateOpportunityStatus(this.tempOpportunity.oppId, {
                  opportunityStatus: val.id
                })
                .then(data => {
                  this.tempObj = {}
                  this.tempOpportunity = {}
                  this.sendingRequest = false

                  this.$toast.add({
                    severity: "success",
                    summary: "Status updated",
                    detail: "Enquiry status has been updated.",
                    life: 5000,
                  })
                })
                .catch(error => {
                  
                  this.sendingRequest = false

                  this.$toast.add({
                    severity: "error",
                    summary: "Status update error",
                    detail: "Couldn't update status.",
                    life: 5000,
                  })
                })
            }
            

          }

    },
    changeStatus(opportunity, event) {
      

          
      this.tempOpportunity = {...opportunity}
      this.tempOpportunityStatuses = []

      if (opportunity.oppStatusName === 'New') {
        this.tempOpportunityStatuses.push(this.opportunityStatuses.find(a => a.oppStatusName === 'Won'))
        this.tempOpportunityStatuses.push(this.opportunityStatuses.find(a => a.oppStatusName === 'Lost'))
        this.tempOpportunityStatuses.push(this.opportunityStatuses.find(a => a.oppStatusName === 'Cancelled'))
        this.tempOpportunityStatuses.push(this.opportunityStatuses.find(a => a.oppStatusName === 'Active'))

      } else if (opportunity.oppStatusName === 'Active') {
        this.tempOpportunityStatuses.push(this.opportunityStatuses.find(a => a.oppStatusName === 'Won'))
        this.tempOpportunityStatuses.push(this.opportunityStatuses.find(a => a.oppStatusName === 'Lost'))
        this.tempOpportunityStatuses.push(this.opportunityStatuses.find(a => a.oppStatusName === 'Cancelled'))

      } else if (opportunity.oppStatusName === 'Cancelled' && !opportunity.productValue) {
        this.tempOpportunityStatuses.push(this.opportunityStatuses.find(a => a.oppStatusName === 'New'))

      } else if (opportunity.oppStatusName === 'Cancelled' && opportunity.productValue) {
        this.tempOpportunityStatuses.push(this.opportunityStatuses.find(a => a.oppStatusName === 'Active'))

      } else if (opportunity.oppStatusName === 'Won' && opportunity.productValue) {
        this.tempOpportunityStatuses.push(this.opportunityStatuses.find(a => a.oppStatusName === 'Active'))

      } else if (opportunity.oppStatusName === 'Lost' && !opportunity.productValue) {
        this.tempOpportunityStatuses.push(this.opportunityStatuses.find(a => a.oppStatusName === 'New'))

      } else if (opportunity.oppStatusName === 'Lost' && opportunity.productValue) {
        this.tempOpportunityStatuses.push(this.opportunityStatuses.find(a => a.oppStatusName === 'Active'))

      } else if (opportunity.oppStatusName === 'Expired') {
        this.tempOpportunityStatuses.push(this.opportunityStatuses.find(a => a.oppStatusName === 'Active'))

      } else {
        this.tempOpportunityStatuses = [...this.opportunityStatuses]

      }

      this.$refs.statuses.toggle(event);
      
    },
    getOptionLabel(data){
      if (data) {
        if (data.dbNameField) {
          return [data.dbNameField]
        } else {
          return data ? data.dbField.split('.').slice(-1) : []
        }
      }
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getToShow(data, col) {

      let a = col.dbField.split('.')
      // 

      let b = ''
      if (a.length > 1) {
        b = data[a[0]] ? data[a[0]][a[1]] : ''
      } else {
        b = data[col.dbField]
      }

      if (col.fieldType === "Currency" && b !== null && b !== undefined) {
        if (b[0] === '£') {
          b = b.substr(1)
        }
        let c = b.toString().split('.')
        // 

        if (c[0]) {
          let d = c[0].split(',')
          if (d.length < 2) {
            c[0] = this.numberWithCommas(c[0])
          }
        }
        // 

        if (c[1]) {
          if (c[1].length === 1) {
            c[1] = `${c[1]}0`
          } else {
            c[1] = c[1].substring(0, 2)
          }
          // 
          return `£${c[0]}.${c[1]}`
        } else {
          return `£${c[0]}.00`
        }
      } else {
        return b
      }
    },
    viewFullHistory() {
      if (this.tempCustomer && this.tempCustomer.customerId)
        this.$router.push({
          path: "customers/" + this.tempCustomer.customerId + "/history",
          params: { custid: this.tempCustomer.customerId },
        });
    },
    viewCustomer() {
      if (this.tempCustomer && this.tempCustomer.customerId)
        this.$router.push({
          path: "customers/" + this.tempCustomer.customerId + "/detail",
          params: { custid: this.tempCustomer.customerId },
        });
    },
    async toggle(event) {
      this.$refs.op.toggle(event);
    },
    openOP(data, col, event) {
      
      
      if (data && event.target && event.target.className === "under_lined") {
        if (col.dbField === 'custName') {
          if (data.customerId) {
            this.tempCustomer = {
              customerId: data.customerId,
              custName: data.custName
            }
            this.customerHistory = []
            this.customerHistoryLoading = true
            this.customerService
              .getCustomerHistory( data.customerId)
              .then(data => {
                if (data.length > 20) {
                  this.customerHistory = data.slice(0, 20);
                } else {
                  this.customerHistory = data
                }
                this.customerHistoryLoading = false
              })
              .catch(err => {
                this.customerHistoryLoading = false
                // this.$toast.add({
                //   severity: "error",
                //   summary: "Error",
                //   detail: "Error while getting customer history.",
                //   life: 5000,
                // })
                this.$store.dispatch('addErrorMessage', {
                  severity: 'error',
                  content: 'Some data was not loaded from "getCustomerHistory/{customerId}"'
                })
              })
            this.toggle(event);
          }
        } else if (col.dbField === 'sQuoteNo') {
          if (data.oppId) {
            this.viewOpportunity(data)
          }
        }
      } 
    },
    getStyle2(col) {
      if (
        col.dbField === 'custName' ||
        col.dbField === 'sQuoteNo'
      ) {
        return 'under_lined'
      }
    },
    colReordered(event) {
      
    },
    colsResized(event) {
      
      
      if (
        event.element && 
        event.element.clientWidth &&
        event.element.textContent
      ) {
        let e = event.element.clientWidth
        

        if (this.colSelectedFields && this.colSelectedFields[0]) {
          
          let a = this.colSelectedFields.find(b => b.dbField.fieldName === event.element.textContent)
          

          this.setSplitButtonLocations()
          if (a && a.id) {
            this.filtersService
              .setUserViewColWidth(a.id, e)
              .then(data => {
                this.setSplitButtonLocations()

                this.$emit('colUpdated', {
                  id: a.id,
                  width: parseInt(e)
                })
              })
              .catch(error => {
                
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: `Error while updating column width.`,
                  life: 5000,
                })
              })
          }
        }
      }
    },
    calculatePageTotals() {
      if (this.data && this.data[0]) {
        this.pageTotal = 0
        this.data.forEach(item => {
          if (item.quoteQty && item.productValue) {
            this.pageTotal += item.quoteQty + item.productValue
          }
        })
        // 
      }
    },
    getButtons(data) {
      let buttons = []
      return buttons
    },
    getActionButtons1() {
      var buttons = [
        {
          label: 'View',
          icon: 'pi pi-info',
          command: (that) => {
            that.viewOpportunity(that.selectedRow)
          }
        },
        {
          label: 'Edit',
          icon: 'pi pi-pencil',
          command: (that) => {
            that.$emit("editOpportunity", that.selectedRow);
          }
        }
      ]
      
      if (
        this.selectedRow 
        && this.selectedRow.oppStatusName === "New"
      ) {
        buttons.push({
          label: 'Delete',
          icon: 'pi pi-trash',
          command: (that) => {
            that.deleteEnquiry(that.selectedRow)
          }
        })
      }

      return buttons
    },
    async loadInlineEditOptions() {
      try {
        this.inlineGrades = await this.opportunityService.getAllActiveQuotationGrades() || []
      } catch (e) { /* options stay empty; cell falls back to read-only text */ }
      try {
        this.inlineProjTypes = await this.opportunityService.getAllActiveProjectTypes() || []
      } catch (e) { /* same */ }
    },
    inlineKindForCol(col) {
      // Grade = active quote's grade (dbField quoteGrade). Enquiry Type = the enquiry's
      // project type (dbField projTypeName, e.g. OTP / Tender / Construction Tender).
      if (col && (col.dbField === 'quoteGrade' || col.fieldName === this.GRADE_HEADER)) return 'grade'
      if (col && (col.dbField === 'projTypeName' || col.fieldName === this.TYPE_HEADER)) return 'type'
      return null
    },
    inlineOptionsFor(kind) {
      return kind === 'grade' ? this.inlineGrades : this.inlineProjTypes
    },
    inlineOptionLabelFor(kind) {
      return kind === 'grade' ? 'quoteGradeName' : 'projTypeName'
    },
    canInlineEdit(row) {
      // Enquiries grid rows expose the active quote as `activeQuoteVerId` (not quoteVerId).
      return !!(row && row.oppId && (row.activeQuoteVerId || row.quoteVerId)) &&
        this.BLOCKED_STATUSES.indexOf(row.oppStatusName) === -1
    },
    isEditingCell(row, kind) {
      return this.inlineEditing &&
        this.inlineEditing.oppId === row.oppId &&
        this.inlineEditing.kind === kind
    },
    startInlineEdit(row, kind, col) {
      if (this.inlineSaving) return
      if (!this.canInlineEdit(row)) return
      // Pre-select the row's current value so the user sees it and changes it.
      this.inlinePendingValue = (kind === 'grade')
        ? (row.quoteGradeId != null ? row.quoteGradeId : null)
        : (row.projTypeId != null ? row.projTypeId : null)
      this.inlineEditing = { oppId: row.oppId, kind: kind, row: row, col: col }
      this.inlineDialogVisible = true
    },
    cancelInlineEdit() {
      this.inlineDialogVisible = false
      this.inlineEditing = null
      this.inlinePendingValue = null
    },
    setNestedValue(obj, path, value) {
      const parts = String(path).split('.')
      let ref = obj
      for (let i = 0; i < parts.length - 1; i++) {
        if (ref[parts[i]] == null || typeof ref[parts[i]] !== 'object') {
          this.$set(ref, parts[i], {})
        }
        ref = ref[parts[i]]
      }
      this.$set(ref, parts[parts.length - 1], value)
    },
    // Saves the pending dropdown value when the user clicks Update. Grade -> active
    // quote; Enquiry Type -> the enquiry's project type. Both persist on the Active Quote's
    // enquiry record and refresh the cell in place.
    async commitInlineEdit() {
      if (!this.inlineEditing) return
      const row = this.inlineEditing.row
      const col = this.inlineEditing.col
      const kind = this.inlineEditing.kind
      const id = this.inlinePendingValue
      if (id == null) {
        this.$toast.add({ severity: 'warn', summary: 'Nothing selected', detail: 'Please choose a value first', life: 3000 })
        return
      }
      this.inlineSaving = true
      try {
        if (kind === 'grade') {
          const res = await this.opportunityService.updateEnquiryQuoteGrade(row.oppId, id)
          this.setNestedValue(row, col.dbField, res.quoteGradeName || '')
          this.$set(row, 'quoteGradeId', res.quoteGradeId)
          this.$toast.add({ severity: 'success', summary: 'Grade updated', detail: 'Quote grade saved', life: 3000 })
        } else {
          const res = await this.opportunityService.updateEnquiryProjType(row.oppId, id)
          this.setNestedValue(row, col.dbField, res.projTypeName || '')
          this.$set(row, 'projTypeId', res.projTypeId)
          this.$toast.add({ severity: 'success', summary: 'Enquiry type updated', detail: 'Enquiry type saved', life: 3000 })
        }
        this.cancelInlineEdit()
      } catch (err) {
        const msg = (err && err.response && err.response.data) ? err.response.data : 'Update failed'
        this.$toast.add({ severity: 'error', summary: 'Update failed', detail: msg, life: 5000 })
      } finally {
        this.inlineSaving = false
      }
    },
  }
}
</script>

<style scoped>
.inline-editable-cell { cursor: pointer; }
.inline-editable-cell:hover { text-decoration: underline dotted; }
</style>
